import { UnderlyingsValueDefinition } from 'models/metadata/readonlyValue.definition';
import type { UnderlyingCodeType } from 'models/underlying/base';
import { connect } from 'react-redux';
import { getUserPreferencesUnderlyingCodeType } from 'state/selectors';
import type { AppState } from 'state/state.model';

interface OwnProps {
  node: UnderlyingsValueDefinition;
}

interface StateProps {
  defaultUnderlyingCodeType: UnderlyingCodeType;
}

export type ProductSummaryUnderlyingsFieldProps = OwnProps & StateProps;

const mapStateToProps = (state: AppState): StateProps => {
  const defaultUnderlyingCodeType = getUserPreferencesUnderlyingCodeType(state);
  return {
    defaultUnderlyingCodeType,
  };
};

export const connectProductSummaryUnderlyingField = connect(mapStateToProps);
